import { ProductsRoute } from 'components/route/products/ProductsRoute';
import { productSSRProps } from 'components/route/products/productSSRProps';

export default function ProProductRoute() {
  return <ProductsRoute />;
}

export const getServerSideProps = productSSRProps;
